module.exports = __webpack_public_path__ + "static/media/mediaplan-icon-grey.333e6b2d.svg";